import { EpidemiologyDataOptions } from "@/data-types/api/epidemiologyData.types";

export const formatOptionsBody = (values: any): EpidemiologyDataOptions | null => {
  if (!values || !values?.startYearInsulin) return null;
  return {
    ageGroups: [
      {
        age: Number(values?.ageIntervalStart1),
        ageMid: Number(values?.ageIntervalMid1),
        scaling: Number(values?.incidenceScalingAge1),
        survivalLastYear: Number(values?.survivalLastYearAge1),
        cumulatives: values?.cumulativesSurvAge1?.map(Number),
      },
      {
        age: Number(values?.ageIntervalStart2),
        ageMid: Number(values?.ageIntervalMid2),
        scaling: Number(values?.incidenceScalingAge2),
        survivalLastYear: Number(values?.survivalLastYearAge2),
        cumulatives: values?.cumulativesSurvAge2?.map(Number),
      },
      {
        age: Number(values?.ageIntervalStart3),
        ageMid: Number(values?.ageIntervalMid3),
        scaling: Number(values?.incidenceScalingAge3),
        survivalLastYear: Number(values?.survivalLastYearAge3),
        cumulatives: values?.cumulativesSurvAge3?.map(Number),
      },
      {
        age: Number(values?.ageIntervalStart4),
        ageMid: Number(values?.ageIntervalMid4),
        scaling: Number(values?.incidenceScalingAge4),
        survivalLastYear: Number(values?.survivalLastYearAge4),
        cumulatives: values?.cumulativesSurvAge4?.map(Number),
      },
    ],
    incRateFirstYearFirstAgeGroup: Number(values?.incidenceRateFirstYear),
    incRateLastYearFirstAgeGroup: Number(values?.incidenceRateLastYear),
    startYearInsulin: Number(values?.startYearInsulin),
    incidenceRatesScalingFactor: Number(values?.incidenceRateScaling),
    lifeExpectancy: Number(values?.lifeExpectancy),
    supports: values?.cumulativesInc?.map(Number),
  };
};
